import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

export interface PosSettingsDto {
    id?: number;
    accountId?: number;
    posEnabled?: boolean;
    printerType?: string;
    storeName?: string;
    storeType?: string;
    headerLogoUrl?: string;
    footerText?: string;
    paperWidth?: string;
    autoPrintIfSubmit?: boolean;
    createdAt?: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
}

export interface PosSettingsUpdateRequest {
    posEnabled?: boolean;
    printerType?: string;
    storeName?: string;
    storeType?: string;
    headerLogoUrl?: string;
    footerText?: string;
    paperWidth?: string;
    autoPrintIfSubmit?: boolean;
}

export interface PrintJobDto {
    id?: number;
    orderId?: number;
    accountId?: number;
    status?: string;
    attempts?: number;
    errorMessage?: string;
    createdAt?: string;
    updatedAt?: string;
    printedAt?: string;
}

class PosService {
    private readonly base = `/admin/pos`;

    getSettings(accountId: number) {
        return fetchWithRetry(API.get<PosSettingsDto>(`${this.base}/settings`, { params: { accountId } }));
    }

    updateSettings(accountId: number, body: PosSettingsUpdateRequest) {
        return fetchWithRetry(API.put<PosSettingsDto>(`${this.base}/settings`, body, { params: { accountId } }));
    }

    getPrintJobs(orderId: number) {
        return fetchWithRetry(API.get<PrintJobDto[]>(`${this.base}/print-jobs`, { params: { orderId } }));
    }
}

export default new PosService();
